export default [
  {
    path: '/myProject',
    name: 'myProject',
    component: () => import('@views/project/myProject.vue'),
    meta: {
      title: '我的项目'
    }
  },
  {
    path: '/evaluateResult',
    name: 'evaluateResult',
    component: () => import('@views/project/evaluateResult.vue'),
    meta: {
      title: '评标结果公示'
    }
  },
  {
    path: '/winResult',
    name: 'winResult',
    component: () => import('@views/project/winResult.vue'),
    meta: {
      title: '中标结果公示'
    }
  },
  {
    path: '/published',
    name: 'published',
    component: () => import('@views/project/published.vue'),
    meta: {
      title: '已发布'
    }
  },
  {
    path: '/orgInfo',
    name: 'orgInfo',
    component: () => import('@views/project/orgInfo.vue'),
    meta: {
      title: '企业信息'
    }
  }, {
    path: '/waitSign',
    name: 'waitSign',
    component: () => import('@views/project/waitSign.vue'),
    meta: {
      title: '待签约'
    }
  }, {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('@views/project/userInfo.vue'),
    meta: {
      title: '个人信息'
    }
  }, {
    path: '/waitEvaluate',
    name: 'waitEvaluate',
    component: () => import('@views/project/waitEvaluate.vue'),
    meta: {
      title: '待评标'
    }
  }, {
    path: '/distributionInfo',
    name: 'distributionInfo',
    component: () => import('@views/project/distributionInfo.vue'),
    meta: {
      title: '待评标'
    }
  },
  {
    path: '/projectDetail1',
    name: 'projectDetail1',
    component: () => import('@views/project/projectDetail1.vue'),
    meta: {
      title: '施工中-标准'
    }
  },
  {
    path: '/personBase',
    name: 'personBase',
    component: () => import('@views/project/personBase.vue'),
    meta: {
      title: '从库内添加人员'
    }
  },
  {
    path: '/projectInvalid',
    name: 'projectInvalid',
    component: () => import('@views/project/projectInvalid.vue'),
    meta: {
      title: '流标项目详情'
    }
  },
  {
    path: '/revocationDetail',
    name: 'revocationDetail',
    component: () => import('@views/project/revocationDetail.vue'),
    meta: {
      title: '撤销详情'
    }
  },
  {
    path: '/projectSteps',
    name: 'projectSteps',
    component: () => import('@views/project/projectSteps.vue'),
    meta: {
      title: '项目进度'
    }
  },
  {
    path: '/projectViewUser',
    name: 'projectViewUser',
    component: () => import('@views/project/projectViewUser.vue'),
    meta: {
      title: '项目进度'
    }
  },
  {
    path: '/projectDetail',
    name: 'projectDetail',
    component: () => import('@views/project/projectDetail.vue'),
    meta: {
      title: '项目详情'
    }
  },
  {
    path: '/projectInfo',
    name: 'projectInfo',
    component: () => import('@views/project/projectInfo.vue'),
    meta: {
      title: '置顶过期项目详情'
    }
  },
  {
    path: '/easyInfo',
    name: 'easyInfo',
    component: () => import('@views/project/easyInfo.vue'),
    meta: {
      title: '过期项目详情'
    }
  },
]
